module.exports = __webpack_public_path__ + "media/customizations/roselyn/logo-new-690ca95b6dd62f9833e05f4926903b5e.png";